import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function updateUploadType2 (id, input) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  try {
    savingStart()
    await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('UploadType2s').doc(id).update(input)
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'uploadType2 / updateData.js')
  }
}
